import React, { useMemo } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import AccessUsers from 'components/AccessUsers/AccessUsers';
import Row from 'components/Common/Row';
import Button from 'kingpin/atoms/Button';
import usePopup from '../../../../hooks/usePopup';
import AssignBoardOwnersPopup from './AssignBoardOwnersPopup';

const Owners = ({
  isLoading,
  owners,
  ownersGreenList,
  onOwnerAdded,
  onOwnerRemoved,
}: {
  isLoading: boolean;
  owners: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  ownersGreenList: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  onOwnerAdded: (
    user: UserManagement.PendingUser | UserManagement.SignedUpUser,
  ) => Promise<void>;
  onOwnerRemoved: (
    user: UserManagement.PendingUser | UserManagement.SignedUpUser,
  ) => Promise<void>;
}) => {
  const { isOpen, open, close } = usePopup();

  const Body = useMemo(() => {
    if (owners.length === 0) {
      return (
        <Button
          type={'Tertiary'}
          size={'Medium'}
          label="Assign Board Owner(s)"
          onClick={open}
        />
      );
    }

    return (
      <Row centerAlign>
        <AccessUsers type={'Users'} users={owners} />
        <div style={{ marginLeft: -4 }}>
          <Button
            size={'X-Small - Circle'}
            type={'Tertiary'}
            icon={'edit-filled'}
            testId={'owners-edit'}
            onClick={open}
          />
        </div>
      </Row>
    );
  }, [open, owners]);

  return (
    <>
      {Body}
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={close}
            shouldScrollInViewport={false}
            autoFocus={false}
          >
            <AssignBoardOwnersPopup
              isLoading={isLoading}
              close={close}
              owners={owners}
              onOwnerAdded={onOwnerAdded}
              onOwnerRemoved={onOwnerRemoved}
              ownersGreenList={ownersGreenList}
            />
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default Owners;
